import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import * as getUser from '../../../redux/profiles/get-user';
import { actions as pharmacyListActions } from '../../../redux/appointmentForm/requests/pharmacy-req';
import { appointmentProgressActions } from '../../../redux/appointmentForm/progress-types';
import {
  selectProgressCareUser,
  selectPharmaciesList,
} from '../../../redux/appointmentForm/selectors';
import { getUserSelector } from '../../../redux/profiles/selectors';

const mapStateToProps = state => ({
  user: getUserSelector(state),
  careUser: selectProgressCareUser(state),
  pharmaciesList: selectPharmaciesList(state),
});

const mapDispatchToProps = {
  getUser: getUser.actions.send,
  getPharmaciesList: pharmacyListActions.send,
  clearPharmacyList: pharmacyListActions.clear,
  loadMorePharmacies: pharmacyListActions.loadMore,
  updateData: appointmentProgressActions.updateNecessaryData,
  updateCareUser: appointmentProgressActions.updateCareUserProfile,
  setPreferredPharmacy: appointmentProgressActions.setPreferredPharmacy,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentPharmacy/enhance.js